module.exports = __webpack_public_path__ + "img/Dai1-new-re.6122f97b.png";